/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/naming-convention */
// ! Any New Type must be moved to ReviewedCartV2.ts file
import { CancellationMessage } from "./cancellation-policy";
import { CartItem, CartCrossSellingItem, SubsItem } from "./menu-items";
import {
    CouponMessageCard,
    SavingsBanner,
    ApplyCouponSuggestion,
    TradeDiscountSuccessCard,
    ApplyCouponsWidgetInfo,
} from "./Coupon";
import { CouponlessSavingsWidgetInfo } from "./CouponlessSavings";
import { RenderingDetails } from "./RenderingDetails";
import { RestaurantDetails } from "./RestaurantDetails";
import { TipDetails, TipExperimentData } from "./TipDetails";
import { UserAddress } from "./Address";
import { DeliveryInstructionDetail, DeliveryInstructionCroutonDetail } from "./DeliveryInstructionDetail";
import { IDeliverySlots } from "./DeliverySlots";
import { UserFlow } from "./UserFlow";

import { PresentationAttributeInfo } from "./PresentationAttribute";
import { DeliverySpeedCrouton, DeliverySpeedPriceInfo } from "./DeliverySpeed";
import { ExtraItem } from "./ExtraItem";
import { SwiggyOneInfo } from "./SwiggyOneInfo";
import { IIrctcPayload, IIrctcTrainOrderAttributes, IIrctcInfo } from "./Irctc";
import { OnPremiseFulfilmentData } from "./OnPremiseFulfilment";
import { IDeliveryPromise } from "./DeliveryPromise";
import { ICartSavedPreferences } from "./LocalCart";
import {
    CartItemWidgetReposition,
    CrossSellInfo,
    MenuItemsWidgetPresentationData,
    PLWidgets,
    XPData,
} from "./ReviewedCartV2";
import { SwiggySixesCroutonAPIInfo } from "./IPLSwiggySixesComms";
import { LottieData } from "./CartHeaderLottie";
import { CancellationDisclaimer } from "./CancellationDisclaimer";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import { INoFeeWeekendData } from "./NoFeeWeekend";
import { CroutonIds } from ".";

enum CtaAction {
    CLEAR_CART = "clearCart",
    GO_TO_HOME = "goToHome",
    GO_TO_SIMILAR_RESTAURANT = "goToSimilarRestaurants",
    GO_TO_LOGIN = "goToLogin",
}

export enum CouponType {
    NORMAL = "NORMAL",
    SUPER = "SUPER",
    SUPER_V3 = "SUPER_V3",
}

export enum UserSuperStatus {
    WAS_SUPER = "WAS_SUPER",
    NOT_SUPER = "NOT_SUPER",
    INVALID_SUPER = "INVALID_SUPER",
    SUPER = "SUPER",
}

export interface CartMenuItemsHeader {
    title: string;
    subtitle: string;
    subtitleColor: string;
    titleColor?: keyof IColors;
    groupTagId: string;
    logoId?: string;
    lottieId?: string;
    backgroundColor?: string;
    showAnimation?: boolean;
}

export enum CART_JOURNEY_ADDITIONAL_CONTEXT_KEYS {
    MOVIE_BEAM = "moviebeam",
    ON_PREMISE_FULFILMENT = "on_premise_fulfilment_order",
}

export const CART_JOURNEY_CTX_KEYS = {
    CART_INITIALIZATION_SOURCE: "cart_initialization_source",
    CART_CATEGORY_TYPE: "cart_category_type",
    REQUEST_CONTEXTS: "request_contexts",
    ADDITIONAL_CONTEXT: "additional_context",
} as const;

export interface CouponDetails {
    coupon_success_card?: CouponMessageCard;
    coupon_error_card?: CouponMessageCard;
    toast_message?: string;
    //coupon_selective_discounting_card to be depreacted
    coupon_selective_discounting_card?: {
        title: string;
        subtitle: string;
        subtitleColor: string;
    };
    is_coupon_auto_applied: boolean;
    is_coupon_valid: boolean;
    coupon_codes?: CouponCodes;
}

export interface CouponCodes {
    restaurant_coupon?: string;
    payment_coupon?: string;
}

export interface ICollapsedBillDetails {
    title?: string;
    totalAmount?: string;
    subtitle?: string;
    strikeoffAmount?: string;
    discountMessage?: string;
    savingsAmount?: string;
    upsellMessage?: string;
    upsellIcon?: string;
    uncollapsed?: boolean;
    surgeApplied?: boolean;
    icon?: string;
    color?: string;
    discountMessageColor?: string;
}

export enum CART_STATUS_CODES {
    SUCCESS = 0,
    FAILURE = 1,
    LOCATION_UNSERVICEABLE = 5,
    RESTAURANT_UNSERVICEABLE = 9,
    RESTAURANT_CLOSED = 6,
    RESTAURANT_CLOSED_WITH_REOPEN_TODAY = 60,
    RESTAURANT_CLOSED_WITH_REOPEN_TOMORROW = 61,
    RESTAURANT_CLOSED_WITH_REOPEN_SPECIFIC_DAY = 62,
    RESTAURANT_CLOSED_WITH_REOPEN_IN_MINUTES = 63,
    RESTAURANT_CLOSED_WITH_NO_INFO = 64,
    RESTAURANT_CLOSED_WITH_REOPEN_SPECIFIC_DATE = 65,
    CITY_CLOSED = 48,
    ITEM_OUTOFSTOCK = 8,
    TOO_MANY_ITEMS = 11,
    ADDRESS_ID_NOT_FOUND_CART_ERROR = 10,
    EXCEEDED_INVENTORY = 13,
    PREORDER_SLOT_EXPIRED_CART_ERROR = 18,
    SUPER_SUBSCRIPTION_INVALID = 21,
    CAFE_AUTHORIZATION_ERROR_CART_ERROR = 29,
    EXTERNAL_VALIDATION_FAILED_CART_ERROR = 30,
    EDIT_ORDER_ERROR = 33,
    EDIT_ORDER_COD_LIMIT_ERROR = 1001,
    MIN_CART_VALUE_ERROR = 41,
    INCREASE_IN_DEMAND = 44,
    RAINS = 45,
    ZONE_NOT_OPEN = 46,
    BLACKZONE = 47,
    TOO_MANY_ITEMS_ON_CART = 43,
    BREAKFAST_SLOT_UNAVAILABLE = 82,
    SELECTED_SLOT_UNAVAILABLE = 83,
    BULK_ORDER_TOTAL_PRICE_IS_BELOW_THRESHOLD = 84,
    SESSION_EXPIRED = 999,
    GIFTING_FOOD_CART_FAILURE = 2,
    GIFTING_FOOD_CART_POST_ORDER_FAILURE = 86,
    // Instamart specific status codes
    IM_CART_FAILURE = 70,
    INSTAMART_ITEM_LEVEL_LIMIT_EXCEEDED = 72,
    INSTAMART_TOTAL_ITEM_LIMIT_EXCEEDED = 73,
    INSTAMART_TOTAL_WEIGHT_LIMIT_EXCEEDED = 74,
    INSTAMART_TOTAL_VOLUME_LIMIT_EXCEEDED = 75,

    // IRCTC NON PNR FLOW
    IRCTC_INVALID_PNR = 97,
    IRCTC_SEAT_NOT_CONFIRMED = 98,
    IRCTC_API_FAILURE = 89,
    IRCTC_CUT_OFF_TIME_EXPIRED = 85,
    IRCTC_STATION_NOT_IN_JOURNEY = 99,
    IRCTC_ORDER_WINDOW_LIMIT_ERROR = 100,
}
export interface ITextPresentationItem {
    text: string;
    icon?: string;
}

export interface IStateItem {
    textPresentation?: ITextPresentationItem[];
}

export interface ICroutonListData {
    text?: string;
    errorText?: string;
    subText?: string[];
    states?: {
        [key: string]: IStateItem;
    };
    icon?: string;
    timer?: number;
    showTimer?: boolean;
    timeout?: number;
    backgroundColor?: string;
    textColor?: keyof IColors;
    timerTextColor?: keyof IColors;
    borderRadius?: string;
}

export interface ICroutonList {
    type: CroutonIds;
    data: ICroutonListData;
}

export interface IToingPresentationalConfig {
    show_lowest_price_guaranteed_popup?: boolean;
    toing_price_comparison_data?: {
        is_free_cash_applicable?: boolean;
        instructions_data?: {
            lottie_id?: string;
            free_cash_multiplier?: string;
        };
        scanning_states_data?: {
            lottie_id?: string;
        };
        rejection_state_halfcard_data?: {
            icon?: string;
            title?: string;
            subtitle?: string;
            error_image?: string;
            cta?: {
                icon?: string;
                text?: string;
            };
        };
        success_state_halfcard_data?: {
            type?: string;
            lottie_id?: string;
            prev_bill_amt?: string;
            current_bill_amt?: string;
            free_cash_amt?: string;
            diff_in_amt?: string;
        };
    };
    delivery_modes_ftue_data?: {
        crouton_max_count?: number;
        new_tag_max_count?: number;
    };
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface ReviewedCartApiResponse {
    cart_header_widget_presentation?: LottieData;
    originalCartId: number;
    cbccWidgetAmount?: number;
    appliedTradeCampaignHeaders: [];
    deliveryFeeCouponBreakup: {
        thresholdFee: number;
        distanceFee: number;
        timeFee: number;
        specialFee: number;
        totalDeliveryFeeDiscount: number;
        discountShare: unknown;
    };
    swiggyOneExclusiveDiscount: number;
    swiggyOneExclusiveRewardValue: number;
    rainMode: boolean;
    flatFeeApplied: boolean;
    newPricingModel: boolean;
    select: boolean;
    superTradeDiscount: boolean;
    taxExclusive: boolean;
    cartId: number;
    result: string;
    email_id: string;
    phone_no: string;
    user_swiggy_money: number;
    cart_menu_items: CartItem[];
    mealItems: [];
    cart_subtotal_without_packing: number;
    cart_subtotal: number;
    last_mile: number;
    taxes: {
        service_tax: number;
        vat: number;
        service_charges: number;
        gst: number;
    };
    del_fee_taxes: number;
    isTaxExclusive: true;
    restaurant_packing_charges: number;
    restaurant_fulfilment_charges: number;
    cart_total_shown_to_coupon: number;
    cart_total: number;
    order_total: number;
    total_without_coupon_discount: number;
    total_packing_charges: number;
    discount_total: number;
    discount_effective: number;
    coupon_discount_total: number;
    coupon_discount_effective: number;
    trade_discount_without_freebie: number;
    trade_discount_total: number;
    trade_discount_effective: number;
    turbo_pay_discount_value_enabled?: boolean; // to show discounted text on turbo pay or not
    batch_opt_in_discount: number;
    discount_total_without_freebie: number;
    super_specific_discount: number;
    user_super_status_details: {
        user_status: UserSuperStatus;
        super_states: string[];
        super_plan_program?: string;
    };
    trade_discount_reward_list: [];
    trade_discount_success_card?: TradeDiscountSuccessCard;
    trade_discount_reward_amount?: number;
    swiggy_money: number;
    coupon_code: string;
    cart_total_count: number;
    rendering_details: RenderingDetails[];
    rendering_model: string;
    restaurant_details?: RestaurantDetails;
    tipDetails: TipDetails;
    tipExperimentData: TipExperimentData;
    total_tax: number;
    display_sequence: Array<string>;
    configurations: {
        show_cutlery_instruction: boolean;
        show_cutlery_opt_in_widget?: boolean;
    };
    cart_type: string;
    address_id: string;
    p_segment_id?: string;
    parent_restaurant_id?: string;
    address_sort: {
        address_weight: number;
        location_weight: number;
    };
    addresses: UserAddress[];
    crossSellingSuggestion?: {
        crossSellTitle?: string;
        crossSellMessage?: string;
        items: CartCrossSellingItem[];
    };
    subscription_items?: SubsItem[];
    subscription_nudge?: {
        show_subscription_nudge: boolean;
        subscription_card: string;
        subscription_nudge_cta: string;
        subscription_nudge_message: string;
        subscription_nudge_subtitle: string;
        subscription_nudge_title: string;
        subscription_type: string;
    };
    subscription_total?: number;
    is_coupon_valid: number;
    discount_message?: string;
    discount_message_type?: CouponType;
    cancellation_message: CancellationMessage;
    free_delivery_discount: number;
    crouton?: {
        message: string;
        icon: string;
    };
    coupon_details?: CouponDetails;
    offerPresentationInfo?: {
        //TODO: deprecate coupon_selective_discounting_card and use cartMessageCard to support coupon as well as trade discounts (without coupon discounts)
        cartMessageCard?: {
            title: string;
            subtitle: string;
            subtitleColor: string;
        };
    };
    group_tag_details?: {
        group_tag_id: string;
        group_tag_type: string;
        group_tag_sub_id: string;
        title_color?: keyof IColors;
        group_background_color?: string;
    }[];
    cart_menu_items_header_list?: CartMenuItemsHeader[];
    item_total: number;
    delivery_charges: number;
    special_fee: number;
    XPData: XPData;
    discount_message_v2: SavingsBanner;
    swiggyOneBenefitsApplicable: boolean;
    iplSwiggySixesCroutonInfo?: SwiggySixesCroutonAPIInfo;
    drop_off_instructions?: DeliveryInstructionDetail[];
    apply_coupon_widget_info?: ApplyCouponSuggestion;
    apply_coupons_widget_info?: ApplyCouponsWidgetInfo;
    couponless_savings_widget_info?: CouponlessSavingsWidgetInfo;
    presentation_attributes_keys?: PresentationAttributeInfo;
    delivery_speed_pricing_info?: DeliverySpeedPriceInfo;
    delivery_speed_crouton?: DeliverySpeedCrouton;
    user_flow_info?: UserFlow;
    is_away_location?: boolean;
    is_new_user: boolean;
    delivery_instructions_crouton?: DeliveryInstructionCroutonDetail;
    slot_details?: IDeliverySlots;
    userSpecificConfigurations?: UserSpecificConfigData;
    widget_info?: {
        [key: string]: {
            visible: boolean;
        };
    };
    cross_sell_items_category?: {
        dessert?: string;
        beverages?: string;
    };
    extra_items?: ExtraItem[];
    swiggyOneInfo?: SwiggyOneInfo;
    category_info_json?: string;
    irctc_data?: IIrctcPayload;
    irctc_info?: IIrctcInfo;
    irctcTrainOrderAttributes?: IIrctcTrainOrderAttributes;
    on_premise_fulfilment_data?: OnPremiseFulfilmentData;
    promises?: IDeliveryPromise[];
    collapsed_bill_details?: ICollapsedBillDetails;
    collapsed_bill_details_variants?: CollapsableBillDetailsVariants;
    is_bulk_cart?: boolean;
    is_splittable_bulk_order?: boolean;
    deals_message_info?: {
        limit_reached_message?: string | null;
        limit_exceeded_message?: string | null;
    };
    savings_stamp_details?: SavingsStampDetails;
    is_incognito_cart?: boolean;
    is_bolt_cart?: boolean;
    is_swiggy_black_otp_applicable?: boolean;
    is_swiggy_black_applicable?: boolean;
    cart_saved_preferences?: ICartSavedPreferences;
    cartItemWidgetReposition?: CartItemWidgetReposition[];
    flash_deals_timer?: ICrazyDealsFlashDealTimer;
    flash_deal_expiry_toast?: ICrazyDealsExpiryToast;
    refresh_menu_flag?: boolean;
    cross_sell_widget_data?: CrossSellInfo;
    is_bolt_experience_enabled_for_bolt_cart?: boolean;
    menu_items_widget_presentation_data?: MenuItemsWidgetPresentationData;
    cancellation_policy_widget?: CancellationDisclaimer;
    croutonList?: ICroutonList[];
    cart_context_drop?: string[];
    toing_presentational_config?: IToingPresentationalConfig;
    cart_splash_lottie?: {
        lottie_key: string;
        lottie_id: string;
        cart_type: string;
    };
    cards?: PLWidgets[];
    no_fee_campaign_data?: INoFeeWeekendData;
}

export interface ApiCartCtaMeta {
    collection_id: string;
    restaurant_id: string;
    city_id: string;
}

export interface ReviewedCart {
    data: ReviewedCartApiResponse | null;
    statusCode: CART_STATUS_CODES;
    statusMessage?: string;
    ctaText?: string;
    ctaAction?: CtaAction;
    ctaIcon?: string | null;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    cta_meta?: ApiCartCtaMeta;
    titleMessage?: string;
    stayOnCartScreen?: boolean;
    sid?: string;
}

export interface ICrazyDealsExpiryToast {
    logo?: string;
    message?: string;
    crouton_timeout?: number;
}

export interface ICrazyDealsFlashDealTimer {
    logo?: string;
    placeholder_message?: string;
    expiry_time?: number;
    show_expiry_timer?: boolean;
}

export interface SavingsStampDetails {
    lottie_title: string;
    lottie_subtitle: string;
}

/* eslint-enable @typescript-eslint/naming-convention */

export type CartCouponPositionXP = "first" | "default";
export enum SelectiveCouponVariantXP {
    DEFAULT = "default",
    DISABLE_CTA = "disable_cta",
    DISABLE_DESCRIPTION = "disable_description",
}

export enum ValueDrivenCrossSellXP {
    COUPON_LOCKED_WIDGET = "coupon_locked_widget",
    ADD_MORE_ITEMS_TEXT = "add_more_items_text",
}

export enum CollapsableBillDetailsVariants {
    DEFAULT = "DEFAULT",
    VARIANT_WITH_SAVINGS = "VARIANT_WITH_SAVINGS",
    VARIANT_WITH_UPSELL = "VARIANT_WITH_UPSELL",
    VARIANT_WITH_SAVING_UPSELL = "VARIANT_WITH_SAVING_UPSELL",
    VARIANT_WITHOUT_SAVING_UPSELL = "VARIANT_WITHOUT_SAVING_UPSELL",
}

export enum PorFlowXP {
    POR_DISABLE = "v1_disable",
    POR_V1_ENABLE = "v1_enable",
    POR_V2_ENABLE = "v2_enable",
}

/* eslint-disable @typescript-eslint/naming-convention */

export interface UserSpecificConfigData {
    [key: string]: unknown;
    selective_coupon_widget_variant?: SelectiveCouponVariantXP;
}
/* eslint-enable @typescript-eslint/naming-convention */
